import { generateQuestionOrder, validateQuestionConfig, getSelectionStats, EXAMPLE_CONFIG } from '../../../helpers/questionSelector';

// Question configuration for farmer verification
const QUESTION_SET = EXAMPLE_CONFIG.FARMER_VERIFICATION;

// Configuration for question display logic
const QUESTION_CONFIG = EXAMPLE_CONFIG.CONFIGS.FIXED_THEN_RANDOM;

// Validate configuration
const validation = validateQuestionConfig(QUESTION_SET, QUESTION_CONFIG);
if (!validation.isValid) {
  console.error('Question configuration validation failed:', validation.errors);
  throw new Error('Invalid question configuration');
}

if (validation.warnings.length > 0) {
  console.warn('Question configuration warnings:', validation.warnings);
}

// Generate the question order for this session
const selectedQuestions = generateQuestionOrder(QUESTION_SET, QUESTION_CONFIG);

// Log selection statistics
const stats = getSelectionStats(QUESTION_SET, selectedQuestions);
console.log('Question Selection Stats:', stats);

// Question screen templates
const questionTemplates = {
  fv_land_type: {
    type: "group_image_pick",
    help: true,
    auto_advance: true,
    timer: {
      time: 15000,
      extend: true,
      pause: false,
      visible: true,
    },
    meta: {
      center: true,
      v2: true,
      hideHalpNavigation: true,
      title: {
        alignment: 'center'
      },
      options: [
        {
          value: 1,
          label: "Plains",
          image: "farmer_verification/land_type_plains"
        },
        {
          value: 2,
          label: "Mountain",
          image: "farmer_verification/land_type_mountain"
        },
        {
          value: 3,
          label: "Desert",
          image: "farmer_verification/land_type_desert"
        },
        {
          value: 4,
          label: "Foot of the mountain",
          image: "farmer_verification/land_type_footmountain"
        }
      ]
    },
    next: {
      rules: {
        visible: true,
        enabled: ["itsDone"],
      },
      visible: true,
      enabled: false,
    },
  },

  fv_crop_type: {
    type: "group_image_pick",
    help: true,
    auto_advance: true,
    timer: {
      time: 15000,
      extend: true,
      pause: false,
      visible: true,
    },
    meta: {
      center: true,
      v2: true,
      title: {
        alignment: 'center'
      },
      hideHalpNavigation: true,
      options: [
        {
          value: 1,
          label: "Rice",
          image: "farmer_verification/crop_type_rice"
        },
        {
          value: 2,
          label: "Wheat",
          image: "farmer_verification/crop_type_wheat"
        },
        {
          value: 3,
          label: "Cotton",
          image: "farmer_verification/crop_type_cotton"
        },
        {
          value: 4,
          label: "Sugarcane",
          image: "farmer_verification/crop_type_sugarcane"
        },
        {
          value: 5,
          label: "Maize",
          image: "farmer_verification/crop_type_maize"
        },
        {
          value: 6,
          label: "Potato",
          image: "farmer_verification/crop_type_potato"
        }
      ],
      other_option: {
        value: 7,
        label: "Other",
        observation: "fv_crop_type_other",
        meta: {
          type: "text",
          placeholder: "Enter your crop type...",
          maxLength: 50,
          minLength: 2,
          required: true,
          helpText: "Please specify your crop type"
        }
      }
    },
    next: {
      rules: {
        visible: true,
        enabled: ["itsDone"],
      },
      visible: true,
      enabled: false,
    },
  },

  fv_crop_pattern: {
    type: "group_image_pick",
    help: true,
    auto_advance: true,
    timer: {
      time: 15000,
      extend: true,
      pause: false,
      visible: true,
    },
    meta: {
      center: true,
      v2: true,
      hideHalpNavigation: true,
      title: {
        alignment: 'center'
      },
      options: [
        {
          value: 1,
          label: "Kharif in summer, Rabi in winter",
          image: "farmer_verification/crop_pattern_summer_winter"
        },
        {
          value: 2,
          label: "Kharif in winter, Rabi in summer",
          image: "farmer_verification/crop_pattern_winter_summer"
        },
        {
          value: 3,
          label: "Both in summer with irrigation",
          image: "farmer_verification/crop_pattern_summer"
        },
        {
          value: 4,
          label: "Both in winter with short duration",
          image: "farmer_verification/crop_pattern_winter"
        }
      ]
    },
    next: {
      rules: {
        visible: true,
        enabled: ["itsDone"],
      },
      visible: true,
      enabled: false,
    },
  },

  fv_farm_challenge: {
    type: "group_image_pick",
    help: true,
    auto_advance: true,
    timer: {
      time: 15000,
      extend: true,
      pause: false,
      visible: true,
    },
    meta: {
      center: true,
      v2: true,
      hideHalpNavigation: true,
      title: {
        alignment: 'center'
      },
      options: [
        {
          value: 1,
          label: "Pest infestation",
          image: "farmer_verification/farm_challenge_pest_infestation"
        },
        {
          value: 2,
          label: "Water salinity",
          image: "farmer_verification/farm_challenge_water_salinity"
        },
        {
          value: 3,
          label: "Lack of fertilizer",
          image: "farmer_verification/farm_challenge_lack_fertilizer"
        },
        {
          value: 4,
          label: "Overuse of pesticide",
          image: "farmer_verification/farm_challenge_pesticide_overuse"
        }
      ]
    },
    next: {
      rules: {
        visible: true,
        enabled: ["itsDone"],
      },
      visible: true,
      enabled: false,
    },
  },

  fv_irrigation_timing: {
    type: "group_image_pick",
    help: true,
    auto_advance: true,
    timer: {
      time: 15000,
      extend: true,
      pause: false,
      visible: true,
    },
    meta: {
      center: true,
      v2: true,
      hideHalpNavigation: true,
      title: {
        alignment: 'center'
      },
      options: [
        {
          value: 1,
          label: "During midday",
          image: "farmer_verification/irrigation_timing_midday"
        },
        {
          value: 2,
          label: "During midnight",
          image: "farmer_verification/irrigation_timing_midnight"
        },
        {
          value: 3,
          label: "Early morning or late evening",
          image: "farmer_verification/irrigation_timing_dusk_dawn"
        },
        {
          value: 4,
          label: "It doesn't matter",
          image: "farmer_verification/irrigation_timing_adhoc"
        }
      ]
    },
    next: {
      rules: {
        visible: true,
        enabled: ["itsDone"],
      },
      visible: true,
      enabled: false,
    },
  },

  fv_residue_practice: {
    type: "group_image_pick",
    help: true,
    auto_advance: true,
    timer: {
      time: 15000,
      extend: true,
      pause: false,
      visible: true,
    },
    meta: {
      center: true,
      v2: true,
      hideHalpNavigation: true,
      title: {
        alignment: 'center'
      },
      options: [
        {
          value: 1,
          label: "Leave in the field to decompose",
          image: "farmer_verification/residue_practice_decompose",
          caption: "Leave in the field to decompose"
        },
        {
          value: 2,
          label: "Burn it immediately",
          image: "farmer_verification/residue_practice_burn",
          caption: "Burn it immediately"
        },
        {
          value: 3,
          label: "Use as livestock fodder",
          image: "farmer_verification/residue_practice_fodder",
          caption: "Use as livestock fodder"
        },
        {
          value: 4,
          label: "Sell in the market",
          image: "farmer_verification/residue_practice_sell",
          caption: "Sell in the market"
        }
      ]
    },
    next: {
      rules: {
        visible: true,
        enabled: ["itsDone"],
      },
      visible: true,
      enabled: false,
    },
  }
};

// Function to generate dynamic screens based on selected questions
const generateDynamicScreens = () => {
  const dynamicScreens = [];

  // Add intro screen
  dynamicScreens.push({
    observation: "fv_intro",
    type: "intro",
    module: "farmer_verification",
    meta: {
     // variant: true,
      v2: true,
     // hiddenHeader: true,
     // hideBottumNavigation: true,
      image: "farmer_verification/fv_intro",
    },
    auto_advance: true,
    timer: {
      time: 10000,
      extend: false,
      pause: false,
      visible: false,
    },
  });

  // Add selected question screens
  selectedQuestions.forEach((questionId, index) => {
    const screenNumber = index + 2; // Screen 2, 3, 4, 5
    const template = questionTemplates[questionId];

    if (template) {
      dynamicScreens.push({
        observation: questionId,
        module: "farmer_verification",
        ...template,
        // Add screen number for debugging
        meta: {
          ...template.meta,
          screenNumber: screenNumber,
          questionOrder: selectedQuestions
        }
      });
    }
  });

  // Add completion screen
  dynamicScreens.push({
    observation: "greatJob",
    type: "module_finish",
    module: "farmer_verification",
    auto_advance: true,
    next: {
      visible: true,
      enabled: true
    },
    timer: {
      time: 3000,
      extend: false,
      pause: false,
      visible: false,
    },
  });

  return dynamicScreens;
};

// Generate the dynamic screens
const dynamicScreens = generateDynamicScreens();

// Log the selected questions for debugging
console.log('Selected Questions for this session:', selectedQuestions);
console.log('Generated Screens:', dynamicScreens.map(s => s.observation));

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  screens: dynamicScreens,
  screen_submit: false,
  //session_store: true,
  // Add metadata about the question selection
  questionSelection: {
    selectedQuestions: selectedQuestions,
    config: QUESTION_CONFIG,
    totalAvailable: QUESTION_SET.length
  }
};